import React, { Component, PropTypes } from 'react';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import { routes } from './routes';

import intercomAnalytics from './services/intercomAnalytics';

let hidden = null;
let visibilityChange = null;
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

export default class Root extends Component {

  componentDidMount() {
    document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
  }

  componentWillUnmount()    {
    document.removeEventListener(visibilityChange, this.handleVisibilityChange);
  }
  onUpdate = () => {
    this.hashLinkScroll();
  };
  handleVisibilityChange = () => {
    if (document[hidden]) {
      console.log(hidden, 'hidden');
    } else {
      this.props.store.dispatch({ type: 'REFRESH_DATA_IN_PAGE_BACKGROUND' });
    }
  };
  permissionCheck = () => {
    const { dispatch, getState } = this.props.store;
    const { pathname } = window.location;
  };
  hashLinkScroll = () => {
    const { hash } = window.location;
    if (hash !== '') {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
      }, 0);
    }
  }
  render() {
    const { store } = this.props;
    // Create an enhanced history that syncs navigation events with the store
    const history = syncHistoryWithStore(browserHistory, store);
//     history.listen(() => intercomAnalytics.trackPage()); - Don't send to intercom for now.
    return (
      <Provider store={store}>
        <Router history={history} onUpdate={this.onUpdate}>
          {routes}
        </Router>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/app/root.js